import { ts_Module_AllValues } from "@/@client/Theasoft_DataClasses"
import { MultiSelect, MultiSelectProps } from "@mantine/core"

export function TheaModuleMultiSelect(props: MultiSelectProps) {
  return (
    <MultiSelect
      data={ts_Module_AllValues
        .filter((v) => v !== "undef")
        .map((v) => ({
          label: v.startsWith("thea")
            ? `thea.${v.substring(4).toLowerCase()}`
            : v,
          value: v,
        }))}
      {...props}
    />
  )
}
